import {Controller} from "@hotwired/stimulus"

// Line item table on the purchase order page: select-all, the selected counter,
// per-row shipment expansion, and passing the selection to Record shipment.
//
// Replaces an inline :javascript block that used Bootstrap's collapse plugin and
// bound `$(document).ready` handlers — those bind again on every Turbolinks visit,
// so the counter ended up updating several times per click.
export default class extends Controller {
    static targets = ["count"]

    connect() {
        this.refresh()

        // Record shipment lives in the page header, outside this controller's
        // element, so the click is caught on the document.
        this.onRecordShipmentClick = (event) => {
            const link = event.target.closest("#record-shipment-btn")
            if (link) this.appendSelectionTo(link)
        }

        document.addEventListener("click", this.onRecordShipmentClick)
    }

    disconnect() {
        document.removeEventListener("click", this.onRecordShipmentClick)
    }

    toggleAll(event) {
        this.checkboxes.forEach((checkbox) => {
            checkbox.checked = event.currentTarget.checked
        })

        this.refresh()
    }

    refresh() {
        const total = this.checkboxes.length
        const checked = this.checkboxes.filter((checkbox) => checkbox.checked).length

        const selectAll = this.element.querySelector("#select-all-line-items")
        if (selectAll) {
            selectAll.checked = total > 0 && checked === total
            selectAll.indeterminate = checked > 0 && checked < total
        }

        if (this.hasCountTarget) {
            this.countTarget.textContent = checked === 0
                ? "0 items selected (all will be included)"
                : `${checked} of ${total} items selected`
        }
    }

    toggleShipments(event) {
        const button = event.currentTarget
        const row = document.getElementById(button.dataset.targetRow)
        if (!row) return

        const open = row.classList.toggle("ice:hidden") === false
        button.setAttribute("aria-expanded", open ? "true" : "false")

        const chevron = button.querySelector("i")
        if (chevron) {
            chevron.classList.toggle("fa-chevron-right", !open)
            chevron.classList.toggle("fa-chevron-down", open)
        }
    }

    // Record shipment should only cover the ticked rows. The original href is kept
    // so repeated clicks don't stack query strings.
    appendSelectionTo(link) {
        if (!link.dataset.originalUrl) link.dataset.originalUrl = link.getAttribute("href")

        const selected = this.checkboxes.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value)
        const url = link.dataset.originalUrl

        link.setAttribute("href", selected.length > 0 ? `${url}?line_item_ids=${selected.join(",")}` : url)
    }

    get checkboxes() {
        return Array.from(this.element.querySelectorAll(".line-item-checkbox"))
    }
}
